import { NestedCompany, NestedCurrency, NestedDeal } from "@revelate/types";

export function getDealValueInCompanyCurrency(
  deal: NestedDeal,
  currencies: NestedCurrency[],
  company: NestedCompany,
) {
  const companyCurrencyId = company.default_currency_id;
  const dealCurrencyId = deal.currency_id;

  if (!companyCurrencyId || !dealCurrencyId) return deal.value;
  if (companyCurrencyId === dealCurrencyId) return deal.value;

  const dealCurrency = currencies.find(c => c.id === dealCurrencyId);
  const exchangeRate = dealCurrency?.exchange_rates?.find(er => er.from_currency_id === er.id && er.to_currency_id === companyCurrencyId);
  const rate = exchangeRate?.rate;

  if (!rate) return deal.value;
  return deal.value * rate;
}
